<script>
import TablePage from '@/found/components/table_page';
import Form from '../form';
import request from '../../../../../../../found/utils/request';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    Form,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['add', 'edit', 'view'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        this.modalConfig.width = '85%';
        this.modalConfig.title = val.name;
        this.formConfig = {
          row,
          code: val.code || '',
        };
        this.openFull();
      } else if (val.code === 'enable') {
        if (!this.selection.length) {
          return this.$message.error('请至少选择一条数据!');
        }
        request
          .post('/cps/v1/terminalNetworkConstruction/enable', this.selection)
          .then((res) => {
            if (res.success) {
              this.$message.success('操作成功');
              this.getList();
            }
          });
      } else if (val.code === 'disable') {
        if (!this.selection.length) {
          return this.$message.error('请至少选择一条数据!');
        }
        request
          .post('/cps/v1/terminalNetworkConstruction/disable', this.selection)
          .then((res) => {
            if (res.success) {
              this.$message.success('操作成功');
              this.getList();
            }
          });
      }
    },
  },
};
</script>
